import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconDroneProps } from './IconDrone.types'
import * as Styled from './styles/IconDrone.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDrone: FC<IconDroneProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDroneProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconDroneProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M15.21 16.176a5.666 5.666 0 0 1-6.382.031m7.754 1.531a8.164 8.164 0 0 1-9.191.047M19 11.688c-2.512 0-5.016.39-5.016 2.343h-4c0-1.953-2.484-2.344-4.984-2.344m6.957-4.144H9v2H5.074m9.926 0v-2h-3.043m6.969 2H15M5 6.5v6.246M2.492 6.031h5.012m8.992 0h5.008M19 6.5v6.246m-7.52-1.211h1.04'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconDrone
